import { get } from 'lodash';
import { sanitize } from '@adjust/dashboard-components';
import errorHandler from '@adjust/dashboard-core/lib/errorHandler/errorHandler';
import { getLocalizedMessage } from '@react/constants/historyEvent/localization/messageLocalization';

/**
 * Audit event message with injected tags for better styling
 *
 * @param {object} event audit event object
 */
function message() {
  'ngInject';
  return {
    restrict: 'E',
    scope: {},
    controller: 'MessageController',
    controllerAs: 'vm',
    bindToController: {
      event: '=ngModel'
    }
  };
}

function MessageController($element) {
  'ngInject';

  const vm = this;

  _prepare();

  /**
   * @ngdoc method
   * @name _prepare
   * @methodOf adjust.accountSettings.controller:MessageController
   *
   * @description
   * Prepare translation of the message and format it
   *
   * @private
   */
  function _prepare() {
    const name = get(vm.event, 'attributes.name', '');
    const parameters = get(vm.event, 'attributes.parameters', {});
    const action = getLocalizedMessage(name, parameters);

    if (action) {
      $element.append(sanitize(action));
    } else {
      $element.append(sanitize(name));
      errorHandler.trackError(new Error('No translation found for: ' + name));
    }
  }
}

export { MessageController, message };
